<template>
  <section>
    <h2 class="h3 mb-3 mt-5">Medical Services</h2>
    <div class="f-form">

      <div class="f-form__third">
        <f-text
          id="providerName"
          label="Provider Name"
          :value="value.provider_name"
          :error="e('provider_name')"
          @input="update('provider_name', $event)"
        />
      </div>

      <div class="f-form__third">
        <f-text
          id="providerContactName"
          label="Provider Contact Name"
          :value="value.provider_contact_name"
          :error="e('provider_contact_name')"
          @input="update('provider_contact_name', $event)"
        />
      </div>

      <div class="f-form__third">
        <f-text
          id="providerPhone"
          label="Provider Phone"
          :value="value.provider_phone"
          :error="e('provider_phone')"
          @input="update('provider_phone', $event)"
        />
      </div>

    </div>
  </section>
</template>

<script>
import FText from '@/components/FormFields/FText'

export default {
  name: 'MedicalServicesSection',
  components: { FText },
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) }
  },
  methods: {
    e(field) {
      return this.errors[field] ? this.errors[field][0] : null
    },
    update(field, val) {
      this.$emit('input', { ...this.value, [field]: val })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Drafts/MedicalServicesSection.vue